import { useCanOpenReturn } from "@babackapp/return-widget-components/hooks/use-can-open-return";
import { Navigate, Outlet } from "react-router-dom";
import { useWidgetParams } from "../hooks/use-widget-params";

// Wraps every step that builds a new return. A customer whose order is closed
// to a new return (`allowOnlyUniqueReturnRequest`) lands on the list of their
// returns, which states why, whatever step they reached: the "new return"
// button, a deep link or the browser history.
//
// The `complete` route stays outside: the creation it runs adds the new return
// to the cache, and redirecting at that moment would unmount the screen before
// it clears the draft and opens the return it just created.
export function NewReturnGate() {
  const { shopId, orderId } = useWidgetParams();
  const canOpenReturn = useCanOpenReturn();

  if (canOpenReturn) return <Outlet />;

  return (
    <Navigate
      replace
      to={`/return-widget/${shopId}/order/${orderId}/return-requests`}
    />
  );
}
